import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import React, { useState } from "react";
import { CompanyType } from '../../../../services/ConfigurationService/types/companyType';
import { useUpdateCompanyMutation } from '../../../../services/ConfigurationService';

export function AddCompanyDialog() {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState<CompanyType>({
        id: '',
        name: '',
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        contactEmail: '',
        phone: ''
    });
    const [updateCompany] = useUpdateCompanyMutation();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleAdd = async () => {
        await updateCompany(form);
        handleClose();
        setForm({
            id: '', name: '', street: '', city: '', state: '', postalCode: '', country: '', contactEmail: '', phone: ''
        });
    };

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                onClick={handleOpen}
            >
                Add Company
            </Button>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Add Company</DialogTitle>
                <DialogContent>
                    <TextField label="ID" name="id" value={form.id} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="Name" name="name" value={form.name} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="Street" name="street" value={form.street} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="City" name="city" value={form.city} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="State" name="state" value={form.state} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="Postal Code" name="postalCode" value={form.postalCode} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="Country" name="country" value={form.country} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="Contact Email" name="contactEmail" value={form.contactEmail} onChange={handleChange} fullWidth margin="dense" />
                    <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} fullWidth margin="dense" />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleAdd} variant="contained" color="primary">Add</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


